import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=58ad6190&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=58ad6190&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ad6190",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ad6190')) {
      api.createRecord('58ad6190', component.options)
    } else {
      api.reload('58ad6190', component.options)
    }
    module.hot.accept("./SideBar.vue?vue&type=template&id=58ad6190&scoped=true", function () {
      api.rerender('58ad6190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/SideBar.vue"
export default component.exports